"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderTargetOptions = void 0;
exports.RenderTargetOptions = {
    Cell: "Cell",
    StickyHeader: "StickyHeader",
    Measurement: "Measurement",
};
//# sourceMappingURL=FlashListProps.js.map